module.exports = __webpack_public_path__ + "img/back-arrow-hover.edff2edb.png";